<div id="form-container">
  <form
    [formGroup]="form"
    id="main-form"
    data-testid="main-form"
    class="col col-m-7 col-l-8 col-xl-8 col-xxl-7 lpy-2"
  >
    <h3 class="ui-heading-4">External Profile</h3>
    <section class="rds-form-field list">
      <p class="rds-form-field__label list-label">Titles</p>
      <div class="list-content">
        @for (title of form.controls.titles.controls; track title) {
          @if(titleListExpanded || $index == 0) {
            <rds-form-field labelPosition="side-left">

              <input rdsInput [formControl]="title" data-testid="titles"/>
            </rds-form-field>
          }
        }
      </div>
    </section>
    @if(form.controls.titles.controls.length > 1){
      @if(!titleListExpanded){
        <button rds-text-button (click)="titleListExpanded = true" class="ms-auto" type="button" data-testid="authors-expand">
          <rds-icon namespace="filled" icon="caret_down"/>
          Show {{form.controls.titles.controls.length -1}} more
        </button>
      }
      @else {
        <button rds-text-button (click)="titleListExpanded = false" class="ms-auto" type="button" data-testid="authors-collapse">
          <rds-icon namespace="filled" icon="caret_up"/>
          Show less
        </button>
      }
    }
    <rds-form-field labelPosition="side-left">
      <rds-control-label>First Name</rds-control-label>
      <input rdsInput formControlName="firstName" data-testid="firstName"/>
    </rds-form-field>
    <rds-form-field labelPosition="side-left">
      <rds-control-label>Last Name</rds-control-label>
      <input rdsInput formControlName="lastName" data-testid="lastName"/>
    </rds-form-field>
    <app-expandable-input [control]="form.controls.institution" label="Institution" data-testid="institution"></app-expandable-input>
    <rds-form-field labelPosition="side-left">
      <rds-control-label>Country</rds-control-label>
      <input rdsInput formControlName="country" data-testid="country"/>
    </rds-form-field>
  </form>
</div>
